import React from 'react';
import { Typography } from 'design-system/src/components/Typography/Typography';
import BuildingIcon from 'design-system/src/assets/icons/buildingOutline.svg?react';
import { type SiteOfCare, SITE_OF_CARE_TYPE_LABELS } from '../../api';
import { formatAddress } from '../../utils';

type SiteOfCareListProps = {
  /** List of sites of care to display */
  sites: SiteOfCare[];
};

/**
 * Renders a list of sites of care with address, site type, and TIN.
 */
const SiteOfCareList: React.FC<SiteOfCareListProps> = ({ sites }) => {
  return (
    <div className="flex flex-col">
      {sites.map((site) => {
        const fullAddress = formatAddress(
          [site.address_line_1, site.address_line_2].filter(Boolean).join(', '),
          site.city,
          site.state,
          site.zipcode,
        );

        return (
          <div key={site.id} className="flex items-center gap-3 border-b border-grayscale-100 py-3 last:border-b-0">
            <div className="flex size-8 shrink-0 items-center justify-center rounded-full bg-green-800">
              <BuildingIcon className="size-4 text-white" aria-hidden />
            </div>
            <div className="flex flex-1 flex-col gap-0.5">
              <Typography styledAs="bodySmallDMSans">{fullAddress}</Typography>
              <Typography styledAs="bodyExtraSmallDMSans" color="var(--grayscale-600)">
                {SITE_OF_CARE_TYPE_LABELS[site.site_type]}
              </Typography>
            </div>
            <Typography styledAs="bodySmallDMSans" color="var(--grayscale-600)" className="shrink-0">
              TIN: {site.tin}
            </Typography>
          </div>
        );
      })}
    </div>
  );
};

export default SiteOfCareList;
